/**
 * GraphQL mutation for batch submission of moderation case feedback.
 *
 * Sends feedback (labels + optional comment) for multiple cases in a single request.
 * Used by the Submit / Submit and Stop actions in the multi-card moderation queue.
 *
 * @see specs/002-moderation-queue-view/contracts/submit-batch-case-feedback.md
 */

import { gql } from '@apollo/client';

export const SUBMIT_BATCH_CASE_FEEDBACK = gql`
  mutation SubmitBatchCaseFeedback($input: BatchCaseFeedbackInput!) {
    submitBatchCaseFeedback(input: $input) {
      success
      submittedCount
      results {
        id
        communityId
        topicName
        caseId
      }
    }
  }
`;
